import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

const StyledSupervisorsListLoader = styled(ContentLoader)`
  height: 242px;
  width: 320px;
`;

export const SupervisorsListLoader = () => (
  <StyledSupervisorsListLoader height={242} width={320}>
    <ellipse
      cx="14.25239"
      cy="52.24716"
      fill="currentColor"
      rx="14.24977"
      ry="14.24977"
    />
    <rect
      fill="currentColor"
      height="7.49988"
      width="88.49855"
      x="39.00198"
      y="43.4973"
    />
    <rect fill="currentColor" height="12" width="75.99875" x="0" y="-0.23185" />
    <rect
      fill="currentColor"
      height="11"
      stroke="null"
      width="15.00013"
      x="83.00126"
      y="1.76812"
    />
    <rect
      fill="currentColor"
      height="5.9999"
      stroke="null"
      width="94.26338"
      x="39.00198"
      y="60.49702"
    />
    <ellipse
      cx="14.25239"
      cy="93.84909"
      fill="currentColor"
      rx="14.24977"
      ry="14.24977"
    />
    <rect
      fill="currentColor"
      height="7.49988"
      stroke="null"
      width="76.82082"
      x="39.00198"
      y="85.09923"
    />
    <rect
      fill="currentColor"
      height="5.9999"
      stroke="null"
      width="121.998"
      x="39.00198"
      y="102.09896"
    />
    <ellipse
      cx="14.25239"
      cy="136.18088"
      fill="currentColor"
      rx="14.24977"
      ry="14.24977"
    />
    <rect
      fill="currentColor"
      height="7.49988"
      width="88.49855"
      x="39.00198"
      y="127.43102"
    />
    <rect
      fill="currentColor"
      height="5.9999"
      stroke="null"
      width="140.97433"
      x="39.00198"
      y="144.43075"
    />
    <ellipse
      cx="14.25239"
      cy="177.78281"
      fill="currentColor"
      rx="14.24977"
      ry="14.24977"
    />
    <rect
      fill="currentColor"
      height="7.49988"
      stroke="null"
      width="103.82558"
      x="39.00198"
      y="169.03296"
    />
    <rect
      fill="currentColor"
      height="5.9999"
      stroke="null"
      width="135.86531"
      x="39.00198"
      y="186.03268"
    />
    <ellipse
      cx="14.25239"
      cy="220.1146"
      fill="currentColor"
      rx="14.24977"
      ry="14.24977"
    />
    <rect
      fill="currentColor"
      height="7.49988"
      stroke="null"
      width="76.09096"
      x="39.00198"
      y="211.36475"
    />
    <rect
      fill="currentColor"
      height="5.9999"
      stroke="null"
      width="112.50984"
      x="39.00198"
      y="228.36447"
    />
  </StyledSupervisorsListLoader>
);
